import { api } from "../Configurations/axios";

const CreateOpportunityPanelCommentsAPI = async (
  opportunitiesPanelsId: string,
  comments: string,
  result: string,
  userEmail: string
) => {
  try {
    const r = await api.post(
      "/OpportunityPanelComments/CreateOpportunityPanelComments",
      {
        opportunitiesPanelsId: opportunitiesPanelsId,
        comments: comments,
        result: result,
        userEmail: userEmail,
      }
    );
    const resp = await r.data;
    return resp;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const GetAllCommentsByOpportunitiesPanelsIdAPI = async (
  opportunitiesPanelsId: string
) => {
  try {
    const result = await api.get(
      `/OpportunityPanelComments/GetAllOpportunityPanelCommentsByOpportunitiesPanelsId/?opportunitiesPanelsId=${opportunitiesPanelsId}`
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const DeleteOpportunitiyPanelCommentsAPI = async (
  opportunityPanelCommentsId: string,
  companyId: string
) => {
  try {
    const result = await api.delete(
      "/OpportunityPanelComments/DeleteOpportunityPanelComments",
      {
        data: {
          opportunityPanelCommentsId: opportunityPanelCommentsId,
          companyId: companyId,
        },
      }
    );
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};

const EditOpportunityPanelCommentsAPI =async (id:string, comments:string, userEmail:string) => {
  try {
    const result = await api.put("/OpportunityPanelComments/EditOpportunityPanelComments",{
      id:id,
      comments:comments,
      userEmail:userEmail,
    });
    const response = await result.data;
    return response;
  } catch (error: any) {
    throw new Error(error.response.data);
  }
};
export {
  CreateOpportunityPanelCommentsAPI,
  GetAllCommentsByOpportunitiesPanelsIdAPI,
  DeleteOpportunitiyPanelCommentsAPI,
  EditOpportunityPanelCommentsAPI
};
